  // 入力文字が正しいかチェックする関数
  // ※大文字/小文字を区別しない
  const checkInput = (text, input) => {
    const tmpText = text.toLowerCase();
    const tmpInput = input.toLowerCase();
    // 大文字／小文字を区別せずに比較
    if(tmpText.startsWith(tmpInput)) {
      return true;
    }
    return false;
  }

  // 入力文字を正規化する関数
  const correctInput = (text, input) => {
    const tmpText = text.toLowerCase();
    const tmpInput = input.toLowerCase();
    // 大文字／小文字を区別せずに比較
    if(tmpText.startsWith(tmpInput)) {
      if (tmpText.startsWith(tmpInput + " ")) {
        return text.slice(0, input.length + 1);
      }
      return text.slice(0, input.length);
    }
    return "";
  }
  
  export { checkInput, correctInput };